module.exports = __webpack_public_path__ + "img/14.deffc1fe.png";